import { createCrudActions } from '../utils/crudGenerator';
import { serializeDatesDeep } from '../utils/serializeDates';

const formatUsers = (data) => {
  if (!data) {
    return [];
  }
  const formatItem = (item) =>
    serializeDatesDeep({
      ...item,
      label: `${item.name} ${item.surname}`,
      value: item._id,
    });

  if (Array.isArray(data)) {
    return data.map(formatItem);
  }
  return formatItem(data);
};

export const {
  fetch: fetchUsers,
  create: createUser,
  update: updateUser,
  delete: deleteUsers
} = createCrudActions('USER', "Usuario", formatUsers);